import { render, staticRenderFns } from "./ServeNotice.vue?vue&type=template&id=6552c460&scoped=true&"
import script from "./ServeNotice.vue?vue&type=script&lang=js&"
export * from "./ServeNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6552c460",
  null
  
)

export default component.exports